import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { CampanhaSelectModule } from '../select';
import { CampanhaSelectFormComponent } from './campanha-select-form.component';

@NgModule({
    imports: [
        SharedModule,
        CampanhaSelectModule
    ],
    declarations: [
        CampanhaSelectFormComponent
    ],
    exports: [
        CampanhaSelectFormComponent
    ]
})
export class CampanhaSelectFormModule { }
